// Global
import React from 'react';
import clsx from 'clsx';

// Local
import styles from './HeroDecor.module.scss';
import { useIsMobile } from 'lib/hooks/useIsMobile';

export const HeroDecor = () => {
  const isMobile = useIsMobile();

  return (
    <div className={clsx(styles.decorWrapper)}>
      <svg
        className={clsx(styles.decorStyleBettyCrocker, styles.decorColor)}
        xmlns="http://www.w3.org/2000/svg"
        width={isMobile ? '375' : '1400'}
        height={isMobile ? '45' : '128'}
        viewBox={isMobile ? '0 0 375 45' : '0 0 1400 128'}
        fill="none"
      >
        {isMobile ? (
          <path
            d="M0 0.626465C0 0.626465 58.8542 42.9957 188.411 42.9957C317.969 42.9957 375 0.626465 375 0.626465V51.9331H187.5H0V0.626465Z"
            fill="currentColor"
          />
        ) : (
          <path
            d="M0 0C0 0 219.722 123.871 703.403 123.871C1187.08 123.871 1400 0 1400 0V149H700H0V0Z"
            fill="currentColor"
          />
        )}
      </svg>
    </div>
  );
};
